import { Link } from "react-router-dom";
import { projects } from "../data/projects";
import PageHero from "../components/PageHero";
import Button from "../components/Button";
import { IconArrow } from "../components/icons";
import { SectionCut } from "../components/Glyphs";
import useReveal from "../components/useReveal";
import styles from "./Projects.module.css";

export default function Projects() {
  useReveal();
  return (
    <>
      <PageHero
        eyebrow="Selected Work"
        code="A · 02"
        title="Built, drawn, and underway."
        subtitle="A cross-section of recent work — single-family residences, accessory dwellings, and the renderings and section studies behind them. Hover for hover, click any project to start a conversation about something similar."
      />

      <section className={styles.list}>
        <div className={styles.listInner}>
          {projects.map((p, i) => {
            const isAlt = i % 2 === 1;
            return (
              <article
                key={p.id}
                className={[
                  styles.project,
                  isAlt ? styles.alt : "",
                  "reveal",
                ].join(" ")}
              >
                <div className={styles.imgWrap}>
                  <div className={styles.img}>
                    <img src={p.photo} alt={p.photoAlt} loading="lazy" />
                    <span className={styles.imgIndex}>
                      A2.{(i + 1).toString().padStart(2, "0")}
                    </span>
                  </div>
                  <SectionCut
                    className={styles.cut}
                    color="#1a1d20"
                    label={String.fromCharCode(65 + i)}
                  />
                </div>
                <div className={styles.copy}>
                  <span className={styles.type}>{p.type}</span>
                  <h2 className={styles.name}>{p.name}</h2>
                  <ul className={styles.specs}>
                    <li>
                      <span>Location</span>
                      <strong>{p.location}</strong>
                    </li>
                    <li>
                      <span>Year</span>
                      <strong>{p.year}</strong>
                    </li>
                  </ul>
                  <p className={styles.blurb}>{p.blurb}</p>
                  <ul className={styles.features}>
                    {p.features.map((f) => (
                      <li key={f}>{f}</li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <section className={styles.cta}>
        <div className={[styles.ctaInner, "reveal"].join(" ")}>
          <h2 className={styles.ctaTitle}>
            Have a site picked out?
          </h2>
          <p className={styles.ctaLede}>
            Tell us about your project — we'll set up a 30-minute call and let
            you know whether we're the right studio for it.
          </p>
          <div className={styles.ctaRow}>
            <Button to="/contact" variant="primary" size="lg">
              Start a Project <IconArrow />
            </Button>
            <Link to="/services" className={styles.ctaLink}>
              How we work <IconArrow />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
